import { ImageProps } from './base';

export default function GooglePay({ width = '64px' }: ImageProps) {
  return (
    <svg
      fill='none'
      height='21'
      style={{ height: 'initial', width }}
      viewBox='0 0 32 21'
      width='32'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>Google Pay</title>
      <rect fill='black' height='21' rx='4' width='32' />
      <path
        clipRule='evenodd'
        d='M15.1133 13.7883V11.145H16.5388C17.123 11.145 17.616 10.9577 18.0179 10.5882L18.1144 10.4946C18.8486 9.72968 18.8004 8.5381 18.0179 7.83043C17.6267 7.45579 17.0908 7.25285 16.5388 7.26326H14.2505V13.7883H15.1133ZM15.1134 10.3437V8.06458H16.5606C16.8715 8.06458 17.1662 8.17905 17.386 8.38719C17.8523 8.82427 17.863 9.55275 17.4128 10.0055C17.193 10.2292 16.8822 10.3541 16.5606 10.3437H15.1134ZM22.1391 9.67243C21.7694 9.34461 21.2656 9.1781 20.6279 9.1781C19.8079 9.1781 19.1916 9.46949 18.7843 10.0471L19.5453 10.5102C19.824 10.1147 20.2045 9.91699 20.6868 9.91699C20.9923 9.91699 21.287 10.0263 21.5175 10.224C21.7426 10.4113 21.8712 10.6819 21.8712 10.9681V11.1606C21.5389 10.9837 21.1209 10.89 20.6064 10.89C20.0062 10.89 19.5239 11.0253 19.1648 11.3011C18.8058 11.5769 18.6235 11.9411 18.6235 12.4042C18.6128 12.8257 18.8004 13.2264 19.1327 13.4969C19.4703 13.7883 19.899 13.934 20.4028 13.934C20.9976 13.934 21.4692 13.6791 21.8283 13.1691H21.8658V13.7883H22.6911V11.0357C22.6911 10.4581 22.5089 10.0002 22.1391 9.67243ZM19.7974 12.9662C19.6205 12.8413 19.5133 12.6384 19.5133 12.4198C19.5133 12.1753 19.6312 11.9723 19.8617 11.811C20.0975 11.6497 20.3923 11.5665 20.7407 11.5665C21.2231 11.5613 21.5983 11.6653 21.8663 11.8735C21.8663 12.2273 21.7216 12.5343 21.4375 12.7945C21.1802 13.0442 20.8318 13.1847 20.4674 13.1847C20.2262 13.1899 19.9903 13.1119 19.7974 12.9662ZM24.5454 15.75L27.4286 9.32379H26.4908L25.1564 12.5291H25.1403L23.7737 9.32379H22.8358L24.7276 13.5021L23.6558 15.75H24.5454Z'
        fill='white'
        fillRule='evenodd'
      />
      <path
        d='M12.1345 10.5726C12.1345 10.3177 12.1131 10.0627 12.0702 9.81293H8.43134V11.2543H10.516C10.4303 11.7174 10.1516 12.1337 9.74432 12.3938V13.3304H10.9876C11.7165 12.68 12.1345 11.7174 12.1345 10.5726Z'
        fill='#4285F4'
      />
      <path
        d='M8.43152 14.2358C9.4712 14.2358 10.3501 13.9028 10.9878 13.3305L9.74451 12.3938C9.39617 12.6228 8.95136 12.7529 8.43152 12.7529C7.424 12.7529 6.5719 12.092 6.26643 11.2075H4.9856V12.1753C5.63941 13.4397 6.97384 14.2358 8.43152 14.2358Z'
        fill='#34A853'
      />
      <path
        d='M6.26655 11.2074C6.10575 10.7443 6.10575 10.2396 6.26655 9.77129V8.80865H4.98552C4.43344 9.86495 4.43344 11.1138 4.98552 12.1701L6.26655 11.2074Z'
        fill='#FBBC04'
      />
      <path
        d='M8.43152 8.22588C8.98351 8.21547 9.51407 8.4184 9.91064 8.78784L11.0146 7.71594C10.3126 7.08112 9.39081 6.7325 8.43152 6.7429C6.97384 6.7429 5.63941 7.54423 4.9856 8.80866L6.26643 9.77649C6.5719 8.88671 7.424 8.22588 8.43152 8.22588Z'
        fill='#EA4335'
      />
    </svg>
  );
}
